import { render, staticRenderFns } from "./catalog-header.vue?vue&type=template&id=7a6b11f0&"
import script from "./catalog-header.vue?vue&type=script&lang=ts&"
export * from "./catalog-header.vue?vue&type=script&lang=ts&"
import style0 from "./catalog-header.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports